'use client';

import {
  Box,
  SystemIcon,
  SystemIconName,
  Typography,
} from '@wishket/design-system';
import { forwardRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { twJoin, twMerge } from 'tailwind-merge';

import {
  openFacebookSharePopup,
  openLinkedInSharePopup,
  openTwitterSharePopup,
} from '@/shared/utils';

interface ShareIconProps {
  name: string;
  icon: SystemIconName;
  onClick: () => void;
}

const ShareIcon = ({ name, icon, onClick }: ShareIconProps) => (
  <Box
    className="flex w-fit cursor-pointer items-center gap-2 px-4 py-3"
    onClick={onClick}
  >
    <SystemIcon
      name={icon}
      className={twJoin('size-4', icon === 'medium_link' && 'text-w-gray-600')}
    />
    <Typography variant="body1" className="text-w-gray-600">
      {name}
    </Typography>
  </Box>
);

interface ShareBoxProps {
  url: string;
  title: string;
  className?: string;
}

const HighlightShareBox = forwardRef<HTMLDivElement, ShareBoxProps>(
  ({ url, title, className }: ShareBoxProps, ref) => {
    const linkParams = { url, title };

    return (
      <AnimatePresence>
        <motion.div
          ref={ref}
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
        >
          <Box
            data-testid="highlight-share-box"
            className={twMerge(
              'z-10 flex w-max flex-col rounded-xl bg-white p-2 shadow-graymedium',
              className
            )}
          >
            <ShareIcon
              name="트위터"
              icon="social_x"
              onClick={() => openTwitterSharePopup(linkParams)}
            />
            <ShareIcon
              name="페이스북"
              icon="social_facebook"
              onClick={() => openFacebookSharePopup(linkParams)}
            />

            <ShareIcon
              name="링크드인"
              icon="social_linked_in"
              onClick={() => openLinkedInSharePopup(linkParams)}
            />
          </Box>
        </motion.div>
      </AnimatePresence>
    );
  }
);

HighlightShareBox.displayName = 'HighlightShareBox';

export default HighlightShareBox;
